import { render } from "./PodAffinity.vue?vue&type=template&id=62f5fdf2"
import script from "./PodAffinity.vue?vue&type=script&lang=js"
export * from "./PodAffinity.vue?vue&type=script&lang=js"

import "./PodAffinity.vue?vue&type=style&index=0&id=62f5fdf2&lang=css"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__